import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { QR_CATEGORIES } from '../constants'

const updateQRCodeCategoryEnable = async (id: number) => {
  await fetchAPI({
    method: 'put',
    path: `/qrcode_categories/${id}/enable`,
  })
}

export const useUpdateQRCodeCategoryEnable = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateQRCodeCategoryEnable, {
    onSuccess: async () => {
      await queryClient.refetchQueries([QR_CATEGORIES])

      toast({
        description: t('views.admin.campaigns.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
